import { __awaiter } from "tslib";
import { useAemConfig } from '@as-react/common-components';
import { authMutations, customerMutations } from '@as-react/common-queries';
import { CheckoutErrorMessage, ErrorMessage, RoutePathname } from '@as-react/common-types';
import { EventEnum } from '@as-react/common-types';
import { EventUtil } from '@as-react/common-utils';
import { CookieUtil } from '@as-react/common-utils';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { GUEST_EMAIL } from '../constants/StorageKeysConstants';
import { analyticsActions } from '../redux/analytics/actions/AnalyticsActions.creators';
import { basketActions } from '../redux/basket/actions/BasketActions.creators';
import BasketUtil from '../util/BasketUtil';
import SessionStorageUtil from '../util/SessionStorageUtil';
import { generatePathUrl } from '../util/URLParamUtil';
import { useFeatureToggle } from './useFeatureToggle';
import { useWishlist } from './useWishlist';
export const useGuestLogin = () => {
    const dispatch = useDispatch();
    const { push } = useHistory();
    const isNewAuth = useFeatureToggle('use_new_auth_flow');
    const [errorMessage, setErrorMessage] = useState(null);
    const [isPending, setIsPending] = useState(false);
    const { defaultRequestParams, servicesEndpoint, isShopLanding, root, isInAuthorMode } = useAemConfig();
    const { wishlistLogin } = useWishlist();
    const { updateEmailMutation } = customerMutations({ servicesEndpoint, defaultRequestParams });
    const { loginGuestMutation } = authMutations({ servicesEndpoint, defaultRequestParams });
    const { mutateAsync: updateEmail } = useMutation(updateEmailMutation());
    const { mutateAsync: loginGuest } = useMutation(loginGuestMutation());
    const guestLogin = (email, exploreMoreCardNumber, customerUUID) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        setErrorMessage(null);
        setIsPending(true);
        try {
            if (exploreMoreCardNumber && customerUUID) {
                yield updateEmail({ email, customerUUID });
            }
            yield loginGuest({ username: email, exploreMoreCardNumber });
            if (!isShopLanding) {
                SessionStorageUtil.setItem(GUEST_EMAIL, email);
            }
            dispatch(analyticsActions.loginStepOption(true));
            dispatch(basketActions.createGetBasicAction());
            if (!isShopLanding) {
                yield wishlistLogin();
            }
            if (!isNewAuth) {
                EventUtil.dispatch(EventEnum.USER_LOGGED_IN, { loggedIn: true });
            }
            CookieUtil.delete('guest');
            push(generatePathUrl(root, `buy.html/${RoutePathname.DELIVERY}`, isInAuthorMode));
        }
        catch (e) {
            const error = e;
            if (!isShopLanding) {
                SessionStorageUtil.removeItem(GUEST_EMAIL);
            }
            if (BasketUtil.isBasketNotInitialized(error)) {
                location.href = `${root}checkout/basket-overview.html`;
                return;
            }
            setErrorMessage(((_a = error.response) === null || _a === void 0 ? void 0 : _a.data.error) === CheckoutErrorMessage.INVALID_EMAIL
                ? ErrorMessage.INVALID_EMAIL
                : ErrorMessage.API_ERROR);
        }
        setIsPending(false);
    });
    return { guestLogin, errorMessage, isPending };
};
